import { useEffect } from "react";
import { toast } from "sonner";
import { PWA_JUST_UPDATED_KEY } from "@/lib/pwa-safe-routes";

/**
 * On mount, checks if the app just reloaded after a PWA auto-update and shows a toast.
 * Renders nothing.
 */
export function PwaUpdatedToast() {
  useEffect(() => {
    if (sessionStorage.getItem(PWA_JUST_UPDATED_KEY)) {
      sessionStorage.removeItem(PWA_JUST_UPDATED_KEY);
      toast.success("Appen ble oppdatert");
    }
  }, []);
  return null;
}
